import store from "../../store/index"
import {loadLanguageAsync} from "../locales/i18n";
import {isAdmin, isLocalAdmin, isSuperAdmin, isVendor, isUserManager} from "./permission";
import routesNames from "../constants/router";
import router from "../../router/index";

const handleGetMeResponse = async function (response) {
  let data = response.data;
  for (let i =0; i < data.permissions.length; i++) {
    data.permissions[i] = data.permissions[i].toLowerCase();
  }

  if(!store.getters["auth/loggedAs"]) {
    localStorage.setItem("userAccount", JSON.stringify(data));
  }

  store.commit("auth/setUserAccount", data);
  let defaultLanguage = data.language.code;
  await loadLanguageAsync(defaultLanguage);
  checkIfMaintenance(data.scopes, data.scopeDefault, data.role.name);
}

const checkIfMaintenance = function (scopes, defaultScope, roleName) {
  if (defaultScope.status.toLowerCase() === "maintenance" && !isAdmin(roleName)) {
    router.push(
      {
        name: routesNames.maintenancePage,
        params: {scope: defaultScope}
      }
    );
  } else {
    redirectToHomePagePerRole(roleName, scopes, defaultScope);
  }
}

// From home page, redirect admin to scope list, local admin to default scope and others to timesheets page
function redirectToHomePagePerRole(roleName, scopes, defaultScope) {
  if (router.currentRoute.path === "/" || router.currentRoute.name === routesNames.maintenancePage) {
    if (isSuperAdmin(roleName)) {
      router.push(routesNames.administration.scopes);
    } else if (isLocalAdmin(roleName)) {
      if (scopes.length === 1) {
        router.push("/scopes/" + defaultScope.name + "-" + defaultScope.id);
      } else {
        router.push(routesNames.administration.scopes);
      }
    } else if (isUserManager(roleName)) {
      router.push(routesNames.administration.users);
    } else if (isVendor(roleName)) {
      router.push(routesNames.invoices);
    } else {
      router.push(routesNames.timesheets);
    }
  }
}

export {
  handleGetMeResponse
}
